import React, {useState} from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link ,useNavigate} from 'react-router-dom'
// import './addQuestion.css'

const CreateQuestion = () => {
  const navigate = useNavigate();
    const [formData, setFormData] = useState({
        questionType: '',
        title: '',
        instructions: '',
        // question: '',
        questions: [
          {
            question: '',
            options: ['']
          }
        ],
        options: [''], // initial Option A
        correctAnswer: '',
        difficulty: '',
        negativeScore: '',
      });
      const [assessmentType, setAssessmentType] = useState('Any Time');
      const [errors, setErrors] = useState({});
    
      const handleChange = (e) => {
        const { name, value } = e.target;
    
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
    
    //   const handleOptionChange = (index, value) => {
    //     const updatedOptions = [...formData.options];
    //     updatedOptions[index] = value;
    //     setFormData((prev) => ({
    //       ...prev,
    //       options: updatedOptions,
    //     }));
    //   };
    // 
    //   const handleAddOption = () => {
    //     setFormData((prev) => ({
    //       ...prev,
    //       options: [...prev.options, ''],
    //     }));
    //   };
    // 
    //   const handleRemoveOption = (index) => {
    //     const updatedOptions = formData.options.filter((_, i) => i !== index);
    //     setFormData((prev) => ({
    //       ...prev,
    //       options: updatedOptions,
    //     }));
    //   };
    const handleQuestionChange = (index, value) => {
      const updatedQuestions = [...formData.questions];
      updatedQuestions[index].question = value;
      setFormData((prev) => ({
        ...prev,
        questions: updatedQuestions,
      }));
    };
    
    const handleOptionChange = (qIndex, optIndex, value) => {
      const updatedQuestions = [...formData.questions];
      updatedQuestions[qIndex].options[optIndex] = value;
      setFormData((prev) => ({
        ...prev,
        questions: updatedQuestions,
      }));
    };
    
    const handleAddOption = (qIndex) => {
      const updatedQuestions = [...formData.questions];
      updatedQuestions[qIndex].options.push('');
      setFormData((prev) => ({
        ...prev,
        questions: updatedQuestions,
      }));
    };
    
    const handleRemoveOption = (qIndex, optIndex) => {
      const updatedQuestions = [...formData.questions];
      updatedQuestions[qIndex].options = updatedQuestions[qIndex].options.filter((_, i) => i !== optIndex);
      setFormData((prev) => ({
        ...prev,
        questions: updatedQuestions,
      }));
    };
    
    const handleAddQuestion = () => {
      setFormData((prev) => ({
        ...prev,
        questions: [...prev.questions, { question: '', options: [''] }],
      }));
    };
    
    const handleRemoveQuestion = (qIndex) => {
      setFormData((prev) => ({
        ...prev,
        questions: prev.questions.filter((_, i) => i !== qIndex),
      }));
    };
    
      const validate = () => {
        let newErrors = {};
        if (!formData.questionType) newErrors.questionType = 'Required';
        if (!formData.title) newErrors.title = 'Required';
        if (!formData.instructions) newErrors.instructions = 'Required';
        if (!formData.question) newErrors.question = 'Required';
        if (!formData.correctAnswer) newErrors.correctAnswer = 'Required';
        if (!formData.difficulty) newErrors.difficulty = 'Required';
        if (!formData.negativeScore) newErrors.negativeScore = 'Required';
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;
        console.log('Submitted data:', formData);
      };
  return (
    <div
    className={`canLisContentWrap bg-ui-gray`}
  >
    <div className="t-wrapper-div">
      <main className="flex-1 p-10 bg-white">

    {/* <div className="card br-15 assessment-sec"> */}
 

    <div className="card-body">
    <Form className="p-1" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Select Question Type</Form.Label>
        <Form.Select name="questionType" value={formData.questionType} onChange={handleChange} isInvalid={!!errors.questionType}>
          <option value="">Select</option>
          <option value="mcq">MCQ</option>
          <option value="subjective">Subjective</option>
        </Form.Select>
        <Form.Control.Feedback type="invalid">{errors.questionType}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Assessment Title</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter title"
          name="title"
          value={formData.title}
          onChange={handleChange}
          isInvalid={!!errors.title}
        />
        <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Instructions</Form.Label>
        <Form.Control
          as="textarea"
          rows={2}
          placeholder="Enter instructions"
          name="instructions"
          value={formData.instructions}
          onChange={handleChange}
          isInvalid={!!errors.instructions}
        />
        <Form.Control.Feedback type="invalid">{errors.instructions}</Form.Control.Feedback>
      </Form.Group>

      {/* <Form.Group className="mb-3">
        <Form.Label>Question</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter question"
          name="question"
          value={formData.question}
          onChange={handleChange}
          isInvalid={!!errors.question}
        />
        <Form.Control.Feedback type="invalid">{errors.question}</Form.Control.Feedback>
      </Form.Group> */}

      {/* <Form.Group className="mb-3">
        <Form.Label>Options</Form.Label>
        {formData.options.map((opt, index) => (
          <Row key={index} className="mb-2 align-items-center">
            <Col>
              <Form.Control
                type="text"
                placeholder={`Option ${String.fromCharCode(65 + index)}`}
                value={opt}
                onChange={(e) => handleOptionChange(index, e.target.value)}
              />
            </Col>
            <Col xs="auto">
              {formData.options.length > 1 && (
                <Button variant="danger" size="sm" onClick={() => handleRemoveOption(index)}>
                  Delete
                </Button>
              )}
            </Col>
          </Row>
        ))}
        <button style={{ height:'36px', textWrap:'nowrap' }}
                      className="ml-4 btnVldt text-base" onClick={handleAddOption}>
          Add Option
        </button>
      </Form.Group> */}

      <Form.Group className="mb-3">
  <Form.Label>Questions</Form.Label>

  {formData.questions.map((q, qIndex) => (
    <div key={qIndex} className="p-2 border rounded mb-4">
      <Row className="align-items-center">
        <Col>
          <Form.Control
            type="text"
            placeholder={`Enter Question ${qIndex + 1}`}
            value={q.question}
            onChange={(e) => handleQuestionChange(qIndex, e.target.value)}
          />
        </Col>
        <Col xs="auto">
          {formData.questions.length > 1 && (
            <button style={{ height:'32px', textWrap:'nowrap'}}
                      className="btnVldt" size="sm" onClick={() => handleRemoveQuestion(qIndex)}>
              Delete Question
            </button>
          )}
        </Col>
      </Row>

      <Form.Label className="mt-3">Options</Form.Label>
      {q.options.map((opt, optIndex) => (
        <Row key={optIndex} className="mb-2 align-items-center">
          <Col>
            <Form.Control
              type="text"
              placeholder={`Option ${String.fromCharCode(65 + optIndex)}`}
              value={opt}
              onChange={(e) => handleOptionChange(qIndex, optIndex, e.target.value)}
            />
          </Col>
          <Col xs="auto">
            {q.options.length > 1 && (
              <button   style={{ height:'32px', textWrap:'nowrap'}}
                      className="btnVldt" size="sm" onClick={() => handleRemoveOption(qIndex, optIndex)}>
                Delete
              </button>
            )}
          </Col>
        </Row>
      ))}

      <button
       type='button'
        size="sm"
        onClick={() => handleAddOption(qIndex)}
     style={{ height:'32px', textWrap:'nowrap'}}
                      className="btnVldt"
      >
        Add Option
      </button>
    </div>
  ))}

  <button type="button" className="btnVldt text-base" style={{ height:'32px',textWrap:'nowrap'}} onClick={handleAddQuestion}>
    Add Question
  </button>
</Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Select Correct Answer</Form.Label>
        <Form.Select name="correctAnswer" value={formData.correctAnswer} onChange={handleChange} isInvalid={!!errors.correctAnswer}>
          <option value="">Select</option>
          {formData.options.map((opt, index) => (
            <option key={index} value={opt}>
              Option {String.fromCharCode(65 + index)}
            </option>
          ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">{errors.correctAnswer}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Difficulty Level</Form.Label>
        <div>
          {['Easy (Entry Level)', 'Medium (Limited Experience)', 'Hard (Working Professional)', 'Expert Level (Subject Matter Expert)'].map((level) => (
            <Form.Check
               
              key={level}
              label={level.charAt(0).toUpperCase() + level.slice(1)}
              name="difficulty"
              type="radio"
              value={level}
              checked={formData.difficulty === level}
              onChange={handleChange}
              isInvalid={!!errors.difficulty}
            />
          ))}
        </div>
        {errors.difficulty && <div className="text-danger">{errors.difficulty}</div>}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Assessment Type</Form.Label>
        <Form.Select
          className="font-size-h4"
          value={assessmentType}
          onChange={(e) => setAssessmentType(e.target.value)}
        >
          <option>Any Time</option>
          <option>Specific Time</option>
        </Form.Select>
      </Form.Group>


      {assessmentType === 'Specific Time' && (
        <>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Assessment Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Assessment Start Time</Form.Label>
                <Form.Control
                  type="time"
                  name="startTime"
                  value={formData.startTime}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Assessment End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Assessment End Time</Form.Label>
                <Form.Control
                  type="time"
                  name="endTime"
                  value={formData.endTime}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </>
      )}

      <Form.Group className="mb-4">
        <Form.Label>Negative Score</Form.Label>
        <Form.Select name="negativeScore" value={formData.negativeScore} onChange={handleChange} isInvalid={!!errors.negativeScore}>
          <option value="">Select</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </Form.Select>
        <Form.Control.Feedback type="invalid">{errors.negativeScore}</Form.Control.Feedback>
      </Form.Group>
<div className='d-flex justify-content-end' style={{gap:'10px'}}>
<button style={{ height:'36px', textWrap:'nowrap', marginRight:'0'}}
                      className="ml-4 btnVldt" type="submit" onClick={()=>navigate('/assessmentGenerator')}>← Back</button>
      <button style={{ height:'36px', textWrap:'nowrap'}}
                      className="ml-4 btnVldt" type="submit">Submit</button>
                         
                      </div>
    </Form>
    </div>
    {/* </div> */}

    </main>
    </div>
    
    </div>
  )
}

export default CreateQuestion